import React from 'react';
import TopPanel from "./../toppanel.js";
import CheckListView from "./../checklists/checklistview.js";
import PaymentsList from "./../payments/payments_table.js";

const errorStyle = {
    color: '#ff5555',
    marginBottom: '15px'
};

class Accounts extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [], // from users
            acc_data: null, // data from profile

            selectedId: null,
            needGoBack: false,
            commandCounter: 0,
            existingUsers:{},
            afterFailState: false,
            selectFirst: {},
            changes: {},
            isLoaded: false,
            errorMessage: null
        };

        this.ensureGlobalValidationFunctionsCreated = this.ensureGlobalValidationFunctionsCreated.bind(this);
        this.successAccountsRequest = this.successAccountsRequest.bind(this);
        this.successProfileRequest = this.successProfileRequest.bind(this);
        this.handleOnSelected = this.handleOnSelected.bind(this);

        this.goBack = this.goBack.bind(this);
        this.getItemText = this.getItemText.bind(this);
    };

    componentWillMount() {
        HC_CheckLoginAndAcc(this, HC_SA);
    }
    componentDidMount() {
        HC_RestoreNavPanel();
        HC_SelectNavItem("li-administrate");

        this.state.commandCounter++;
        HC_SendRequest("users", null, this.successAccountsRequest.bind(this), null);
        HC_SubscribeHammerEvent(this.refs.hc_user_content, "swiperight", this.goBack);
    }
    componentWillUnmount() {
        HC_UnsubscribeHammerEvent(this.refs.hc_user_content, "swiperight");
    }

    successProfileRequest(reply) {
        this.state.commandCounter--;
        if (this.state.commandCounter == 0) { // don't update model is there're other commands in queue
            this.setState({acc_data: reply.data});
        }
    }
    successAccountsRequest(reply) {
        if (this.state.needGoBack)
            this.goBack();
        this.state.commandCounter--;
        if (this.state.commandCounter == 0) { // don't update model is there're other commands in queue
            this.state.changes = {};
            if (this.state.selectFirst) {
                var data = {"owner_id": reply.data[0].owner_id};
                this.state.commandCounter++;
                HC_SendRequest("get_account_by_sa", data, this.successProfileRequest, null);
                this.state.selectedId = null;
            }
            HC_SetDataAndSelectedItem(this, reply.data, {needGoBack: false, afterFailState: false});
        }
        this.setState({isLoaded: true});
    }

    handleOnSelected(e ) {
        let state = {selectedId: e, changes: {},  afterFailState: false};
        if (e != this.state.selectedId) {
            if (this.state.data.length > 0 && this.state.data[0].id == -1)
                this.state.data.shift();  // remove fake New User item

            var item = this.state.data.find(function(o) {return o.id == e;});
            if (item.is_subscribed) {
                var data = {"owner_id": item.owner_id};
                this.state.commandCounter++;
                HC_SendRequest("get_account_by_sa", data, this.successProfileRequest, null);
            }
            else
                this.state.acc_data = null;
        }
        if (HC_DeviceType() == HC_CONST.SCR_PHONE) {
            this.setState(state);
            HC_SwitchRPanel();
        } else
            this.setState(state);
    }
    getItemText(o) {
        let i = 0;
        let strings = [
            HC_LANG.ADM_EMAIL + ": " + (o.owner_email ? o.owner_email : ''),
            "Owner Name:" + (o.owner_name ? o.owner_name : ''),
            HC_LANG.ADM_LAST_LOGIN + ": " + (o.last_login ? HC_FormatDateFull(o.last_login) : HC_LANG.DUE_NEVER),
            HC_LANG.ADM_NUM_LOGINS + ": " + (o.login_count ? o.login_count : '0')
        ].map(function(s) {return (<div key={i++}>{s}</div>);});
        return <div>{strings}</div>;
    }
    goBack() {
        HC_RestoreRPanel();
        if (this.state.data.length > 0 && this.state.data[0].id == -1) {
            this.state.data.shift();  // remove fake New User item
            this.state.selectedId = this.state.data.length > 0 ? this.state.data[0].id : null;
        }
        this.setState({afterFailState:false});
    }


    ensureGlobalValidationFunctionsCreated () {
        if (window.HC_OWNERS_VALIDATION != this) {
            window.HC_OWNERS_VALIDATION = this;
            window.HC_AdmAccValidatePassword = function (str) {
                if (str === '')
                    return [true, ''];
                return HC_ValidatePassword(str);
            }.bind(this);
        }
    }

    adminLogin() {
        let item = HC_CurrentItem(this);
        this.setState({errorMessage: null});
        HC_SendRequest('supervisor_login', {account_id: item.id}, reply => {
           HC_SetLoginSettings(reply);
           HC_GoMainPage();
        }, (errorStatus, errorText) => {
            this.setState({errorMessage: errorText});
        });
    }

    render() {
        let text;

        const {errorMessage} = this.state;

        this.ensureGlobalValidationFunctionsCreated();
        let deviceType = HC_DeviceType();
        let item = HC_CurrentItem(this);

        let licon = '', liconAction = null;
        if (deviceType == HC_CONST.SCR_PHONE) {
            licon = 'fa-angle-left';
            liconAction = this.goBack;
        }

        if (item != null) {
            text = item.name;
        }

        return (
            <div id="panel-checklists" style={{height:"100%"}}>
                <div className="hc-list-panel hc-br">
                    <TopPanel text={HC_LANG.ADM_CAPTION} licon="fa-bars" onLiconClick={HC_ToggleNavPanel} />
                    <CheckListView 
                        data={this.state.data} 
                        getCaption={o => o.name}
                        getSearchString={o => `${o.name}${o.owner_email}${o.owner_name}${o.owner_name}`}
                        getText={this.getItemText}
                        selectedId={this.state.selectedId}
                        onSelect={this.handleOnSelected}
                        showSearch={true}
                    />
                </div>
                <div ref="hc_user_content" className="hc-content-panel">
                    <div className="hc-internal-panel">
                        <TopPanel text={text} licon={licon} onLiconClick={liconAction}/>
                        {this.state.isLoaded && <div style={{position:"absolute", top:"60px", bottom:0, width:"100%", overflowY:"auto", WebkitOverflowScrolling:'touch' }}>
                            <AccountInfo data={item} />
                            <div style={{padding: '1rem'}}>
                                {errorMessage && <div className="" style={errorStyle}>{errorMessage}</div>}
                                <input type="button" className="hc-button" value="Enter Account" onClick={this.adminLogin.bind(this)} disabled={this.state.is_deleted} />
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        );
    }
}

class StripeInfo extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            changes: {}
        };

        this.addSubscriptionDays = this.addSubscriptionDays.bind(this);
        this.onFieldChanged = this.onFieldChanged.bind(this);
    };

    onFieldChanged(o) {
        this.state.changes[o.target.getAttribute('data-key')] = o.target.value;
        this.setState({changes: this.state.changes});
    }

    addSubscriptionDays() {

    }

    render() {
        if ($.isEmptyObject(this.props.data))
            return (<div></div>);

        let capStyle = {display: "inline-block", flex: "0 1 10rem" };
        capStyle.flex = capStyle.WebkitFlex = "0 1 10rem";
        let labStyle = {marginBottom: "3%", display:"flex"};

        let dt, payments, planName, daysLeft, i, nextPayment, planDays, stripeId ;
        dt = this.props.data;

        if (dt != null) {
            planName = dt.plan ? dt.plan : "";
            if (dt.plan && !dt.is_trial) {
                nextPayment = (
                    <div>
                        <span className="hc-f-l">{HC_LANG.PRO_NEXT_PAYMENT}</span>
                        <table className="table" style={{width:'100%', marginTop:'10px', marginBottom:'20px'}}>
                            <tbody>
                            <tr>
                                <td style={{paddingLeft:0, paddingTop:'10px', paddingBottom:'10px'}}>
                                    <i className="fa fa-history hc-fa-small"
                                       style={{marginRight:'5px', paddingTop:'10px', paddingBottom:'10px'}}/>
                                    <span style={{marginRight:"10px"}}>{planName}</span>
                                </td>
                                <td className="hc-f-l" style={{paddingTop:'10px', paddingBottom:'10px'}}>
                                    {dt.waiting_payment ? HC_LANG.PRO_WAITING_PAYMENT : (HC_LANG.PRO_WILL_BE_PAID + " " + dt.next_payment)}
                                </td>
                                <td style={{textAlign:'right', paddingRight:0, paddingTop:'10px', paddingBottom:'10px'}}>{dt.next_amount}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                );
            }
            if (!dt.is_trial && dt.payments && dt.payments.length > 0) {
                payments = ( <PaymentsList data={dt.payments}/> );
            }

            let new_days_left = this.state.changes.new_days_left != undefined ? this.state.changes.new_days_left : dt.days_left;
            let addDaysBtn = "hc-button";
            let opts = {};
            if ($.isEmptyObject(this.state.changes)) {
                addDaysBtn += ' hc-button-off';
                opts['disabled'] = 'disabled';
            }

            if (new_days_left > 0 ) {
                planDays = (
                    <div style={labStyle}>
                        <span className="hc-f-l" style={capStyle} >Plan:</span>
                        <span className="hc-f-l">{planName}</span>
                    </div>);

                daysLeft = (<div style={{marginBottom: "8%", display:"flex"}}>
                    <span className="hc-f-l" style={{display: "inline-block", flex: "0 1 10rem", marginTop: "0.3rem" }}>Days Left:</span>
                    <input ref="hc_add_days" type="number" style={{width: "9rem"}} data-key="new_days_left"
                           className="form-control hc-f4" value={new_days_left} onChange={this.onFieldChanged}
                           data-vfunc="HC_ValidateNotEmptyField"/>
                <span className="hc-f-l" style={capStyle}>
                    <button className={addDaysBtn} {...opts} onClick={this.addSubscriptionDays}
                            style={{marginLeft: "1rem"}}>Add days</button>
                </span>
                </div>);
            }
        }

        if (this.props.data.customer_id != undefined) {
            stripeId = (
                <div style={labStyle}>
                    <span className="hc-f-l" style={capStyle} >Stripe ID</span>
                    <span className="hc-f-l"  >{this.props.data.customer_id}</span>
                </div>
            )
        }
        return(
            <div className="hc-f4" style={{padding:"5%", width: "100%"}}>
                {stripeId}
                {planDays}
                {daysLeft}
                {nextPayment}
                {payments}
            </div>
        )
    }
}

class AccountInfo extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            changes: {},
            commandCounter: 0
        };

        this.onFieldChanged = this.onFieldChanged.bind(this);
        this.handleOnUpdated = this.handleOnUpdated.bind(this);
        this.successUpdatedRequest = this.successUpdatedRequest.bind(this);
    };

    onFieldChanged(o) {
        this.state.changes[o.target.getAttribute('data-key')] = o.target.value;
        this.setState({changes: this.state.changes});
    }

    successUpdatedRequest(reply) {
        HC_ShowMessage("User was updated!");
        this.setState({changes: {}});
    }

    handleOnUpdated(o) {
        if (!HC_Validate())
            return;

        let data = {};
        data.owner_id = this.props.data.owner_id;
        data.acc_login = true;
        data.owner_email = this.state.changes.owner_email;
        data.new_password = this.state.changes.newPassword;

        this.state.commandCounter++;
        HC_SendRequest("edit_user_by_sa", data, this.successUpdatedRequest, null);
    }

    getImmutableFields(o) {
        var items = [];
        items.push({"field_caption": "Account ID", "field_value" : o.id});
        items.push({"field_caption": "User ID", "field_value" : o.owner_id});
        items.push({"field_caption": HC_LANG.SU_CO_NAME, "field_value" : o.name});
        items.push({"field_caption": HC_LANG.SU_CO_TYPE, "field_value" : o.company_type});
        items.push({"field_caption": HC_LANG.SU_CO_ADR, "field_value" : o.street});
        items.push({"field_caption": 'Phone', "field_value" : o.phone});
        items.push({"field_caption": HC_LANG.SU_ZIP, "field_value" : o.zip});
        items.push({"field_caption": HC_LANG.SU_CITY, "field_value" : o.city});
        items.push({"field_caption": HC_LANG.SU_COUNTRY, "field_value" : o.country});
        items.push({"field_caption": HC_LANG.SU_FNAME, "field_value" : o.first_name});
        items.push({"field_caption": HC_LANG.SU_LNAME, "field_value" : o.last_name});
        items.push({"field_caption": "Deleted", "field_value" : (o.is_deleted ? 'Yes' : 'No')});
        return items;
    }

    render() {
        if (this.props.data == null)
            return (<div></div>);

        let capStyle = {display: "inline-block", flex: "0 1 10rem" };
        capStyle.flex = capStyle.WebkitFlex = "0 1 10rem";
        let labStyle = {marginBottom: "3%", display:"flex"};
        let capTopStyle = {display: "inline-block", flex: "0 1 10rem", marginTop: "0.4rem" };
        capTopStyle.flex = capTopStyle.WebkitFlex = "0 1 10rem";
        let div100Right = {display: "inline-flex", width: "60%", maxWidth: "300px", marginBottom:"0"};
        div100Right.flex = div100Right.WebkitFlex = "1 1 200px";
        let errStyle = {width: '100%', display:"none", margin: "0 0 0.3rem 10rem"};

        let fields = this.getImmutableFields(this.props.data);
        let i = 0;
        const readOnlyItems = fields.map(function (o) {
            return (
                <div key={i++} style={labStyle}>
                    <span className="hc-f4 hc-f-l " style={capStyle} >{o.field_caption}</span>
                    <span className="hc-f4 hc-f-l " >{o.field_value}</span>
                </div>);
        });

        let email = this.state.changes.owner_email != undefined ? this.state.changes.owner_email : this.props.data.owner_email;
        let newPassword = this.state.changes.newPassword != undefined ? this.state.changes.newPassword : undefined;

        let classBtn = 'hc-button';
        let opts = {};
        if ($.isEmptyObject(this.state.changes)) {
            classBtn += ' hc-button-off';
            opts['disabled'] = 'disabled';
        }

        return(
            <div style={{ borderBottom: "solid 1px #e6eaed", width: "100%", padding: "5% 5% 5%"}}>
                {readOnlyItems}
                <div className="hc-flex-display" style={labStyle}>
                    <div id="hc-adm-email" style={capTopStyle} className="hc-f4 hc-f-l">{HC_LANG.ADM_EMAIL}</div>
                    <div style={div100Right}>
                        <input id="hc-adm-email-input" className="form-control hc-validated hc-f4"
                               style={{width: '100%'}} data-key="owner_email"
                               type="email" placeholder={HC_LANG.ADM_EMAIL}
                               value={email} onChange={this.onFieldChanged}
                               data-vfunc="HC_ValidateEmail" data-vtext="hc-adm-email-error" data-vcaption="hc-adm-email"
                               autoComplete="off" />
                    </div>
                </div>
                <div id="hc-adm-email-error" style={errStyle}/>
                <div className="hc-flex-display" style={labStyle}>
                    <div id="hc-adm-pass" style={capTopStyle} className="hc-f4 hc-f-l ">{HC_LANG.ADM_PWD}</div>
                    <div style={div100Right}>
                        <input id="hc-adm-pass-input" className="form-control hc-validated hc-f4"
                               style={{width: '100%'}} data-key="newPassword"
                               type="password" placeholder={HC_LANG.ADM_NEW_PASS}
                               value={newPassword} onChange={this.onFieldChanged}
                               data-vfunc="HC_AdmAccValidatePassword" data-vtext="hc-adm-pass-error" data-vcaption="hc-adm-pass"
                               autoComplete="off"/>
                    </div>
                </div>
                <div id="hc-adm-pass-error" style={errStyle}/>
                <div className="hc-flex-display" style={labStyle}>
                    <div style={capStyle} className="hc-f4 hc-f-l"></div>
                    <div style={div100Right}>
                        <button className={classBtn} onClick={this.handleOnUpdated} {...opts}>
                            Update
                        </button>
                    </div>
                </div>
            </div>)
    }
}

module.exports = Accounts;


// WEBPACK FOOTER //
// ./admins/accounts.js